import React, { useState, useEffect } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CancelIcon from '@mui/icons-material/Cancel';
import moment from 'moment';
import PublicModalWrappers from '../public/PublicModalWrappers';

const SharedList = props => {
  const [modalIsOpen, closeModal] = useState(false);

  const [removingEmail, setRemovingEmail] = useState('');

  const handleClick = (item) =>{
    closeModal(true);
    setRemovingEmail(item.sharedAccount.username);
  }

  const handleRemove = () =>{
    console.log(removingEmail)
  }

  return (
    <div className="ShareCampaign_share-list">
      {props.data.map((item, idx) => (
        <div className="ShareCampaign_share-item" key={idx}>
          <div className="ShareCampaign_share-item_name">
            {item.sharedAccount.firstName === '' &&
            item.sharedAccount.lastName === ''
              ? `Unknown`
              : item.sharedAccount.firstName + item.sharedAccount.lastName}
          </div>
          <div className="ShareCampaign_share-item_email">
            {item.sharedAccount.username}
          </div>
          <div className="ShareCampaign_share-item_info">
            <div>
              {item.statusEvents &&
                item.statusEvents[0] &&
                `Invite Sent: ${moment(
                  Date.parse(item.statusEvents[0].updatedAt)
                ).format('DD-MMM-YYYY')}`}
            </div>
            <div>
              {item.statusEvents &&
                item.statusEvents[1] &&
                `Active Since: ${moment(item.statusEvents[1].updatedAt).format(
                  'DD-MMM-YYYY'
                )}`}
            </div>
            <div>
              {item.statusEvent &&
                item.statusEvent[2] &&
                `Removed On:${moment(item.statusEvent[2].updatedAt).format(
                  'DD-MMM-YYYY'
                )}`}
            </div>
          </div>
          <div
            className="ShareCampaign_share-item_remove"
            onClick={() => handleClick(item)}
          >
            <CancelIcon style={{ fill: '#EF4444', paddingRight: 5 }} />
            Delete
          </div>
        </div>
      ))}

      <PublicModalWrappers
        isOpen={modalIsOpen}
        close={() => closeModal(!modalIsOpen)}
        width="40%"
      >
        <div className="ShareCampaign_send-invite-area">
          <div className="ShareCampaign_mail-icon">
            <HighlightOffIcon style={{ fill: '#EF4444' }} />
          </div>

          <div
            className="ShareCampaign_first-invitation-title"
            style={{ margin: 5 }}
          >
            Remove access
          </div>
          <div
            className="ShareCampaign_first-invitation-description"
            style={{ margin: 5, padding: ' 0 5rem 0 5rem' }}
          >
            Are you sure you wish to remove access to {removingEmail}
          </div>

          <div className="ShareCampaign_send-invite-button-area">
            <div className="ShareCampaign_cancel-button" onClick={() => closeModal(false)}>Cancel</div>
            <div
              className="ShareCampaign_confirm-button"
              style={{ background: '#EF4444' }}
              onClick={handleRemove}
            >
              Remove
            </div>
          </div>
        </div>
      </PublicModalWrappers>
    </div>
  );
};

export default SharedList;
